import { defineMessages } from "react-intl";

export default defineMessages({
    addRole: {
        id: "hubs.components.hubRoles.addRole",
        defaultMessage: "Add Role",
    },
});
